import React from "react";
import {
  FormRedirectionPage,
  IFormRedirectionPageProps,
} from "./FormRedirectionPage";

export const ExpiryMessagePage: React.FC<
  Omit<IFormRedirectionPageProps, "redirectUrl">
> = ({ header, message }) => {
  return <FormRedirectionPage header={header} message={message} />;
};
